import React from "react";

export default function BucketsTableMaxCoolent_Jupiter(props) {
  let { data } = props;
  // console.log("data__",data);
  // console.log("props---in",props);
  return (
    <>
      {(data.length == 0) ? "<tr><td colSpan={2}>No data found</td></tr>" : data.map((x, index) => {
        return (<tr key={x.key}>
          <td scope="row ">{x.key.vehicleId}</td>
          <td >{(x.Max_BCS_Coolant_In.value)} </td>
        </tr>)
      })}
    </>
  );
}

